import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, LanguageContext, NotificationContext } from '../context'
import { useNavigate } from 'react-router-dom'
import { AddressInput } from '../components/UI'
import PhoneCustomInput from '../components/UI/PhoneInput'


function MyProfile() {

  const { signOut, userData, updateUser } = useContext(AuthContext)
  const { toast, prompt } = useContext(NotificationContext)
  const { t } = useContext(LanguageContext)

  const navigate = useNavigate()

  const [currentData, setCurrentData] = useState({ ...(userData || {}) })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setCurrentData({ ...userData })
  }, [userData])

  const handleChange = (key) => (e) => {
    const keyComponents = key.split('.')
    if (keyComponents.length === 1) {
      setCurrentData({ ...currentData, [key]: e.target.value })
      return
    }
    const [parentKey, index, childKey] = keyComponents
    const newChildren = [...currentData[parentKey]]
    newChildren[index] = { ...newChildren[index], [childKey]: e.target.value }
    setCurrentData({ ...currentData, [parentKey]: newChildren })
  }

  const handlePhoneChange = (e) => {
    setCurrentData({ ...currentData, phone: e })
  }

  const handleSignOut = async () => {
    await signOut()
    navigate('/')
  }

  const handleSaveChanges = async () => {
    setLoading(true)
    const processedUserData = { ...currentData }
    if (processedUserData.children) {
      processedUserData.children = processedUserData.children.filter(child => child.firstname)
    } else {
      processedUserData.children = []
    }
    await updateUser(processedUserData)
    setLoading(false)
    toast({ message: t('profile.edit_success'), variant: 'success' })
  }

  const handleAddChild = () => {
    setCurrentData({ ...currentData, children: [...(currentData.children || []), { firstname: '' }] })
  }

  const handleRemoveChild = (index) => () => {
    const newChildren = [...currentData.children]
    newChildren.splice(index, 1)
    setCurrentData({ ...currentData, children: newChildren })
  }

  return (
    <div className='content-parent'>
      <h3 className='text-3xl font-semibold mb-16 mt-12 my-profile-title'>{t('profile.title')}</h3>
      <div className="max-w-96 mx-auto text-left">

        <div>
          <div className='mb-4'>
            <label className='block mb-2'>
              {t('generic.firstname')}
            </label>
            <input type='text' className='border' name='firstname' autoComplete='on' value={currentData.firstname} onChange={handleChange('firstname')} />
          </div>
          <div className='mb-4'>
            <label className='block mb-2'>
              {t('generic.lastname')}
            </label>
            <input type='text' className='border' name='lastname' autoComplete='on' value={currentData.lastname} onChange={handleChange('lastname')} />
          </div>
          <div className='mb-4'>
            <label className='block mb-2'>
              {t('generic.email')}
            </label>
            <input type='text' className='border' name='email' autoComplete='on' value={currentData.email} onChange={handleChange('email')} disabled />
          </div>
          <div className='mb-4'>
            <label className='block mb-2'>
              {t('generic.phone')}
            </label>
            <div className='flex w-full'>
              <PhoneCustomInput
                value={currentData.phone}
                onChange={handlePhoneChange}
              />
            </div>
          </div>

          <div className='mb-4'>
            <label className='block mb-2'>
              {t('generic.address')}
            </label>
            <AddressInput name='address' value={currentData.address} onChange={handleChange('address')} />
          </div>
          <div className='mb-2'>
            <label className='block mb-2'>
              {t('generic.children')}
            </label>
            {currentData.children && currentData.children.map((child, index) =>
              <div key={`child-input-${index}`} >
                <input type='text' className='border' name='children' value={child.firstname} onChange={handleChange(`children.${index}.firstname`)} />
                <a onClick={handleRemoveChild(index)} className='delete-link my-3 inline-block'>{t('generic.delete')}</a>
              </div>
            )}
          </div>
          <button onClick={handleAddChild} className='light'>{t('profile.add_child')}</button>
          <div className='mb-4'></div>
          {/* <label className='block mb-2'>
            {t('generic.notifications')}
          </label> */}
          <div className='mb-8 flex justify-between items-center'>
            <label className='mb-2'>
              {t('profile.email_notifications')}
            </label>
            <label className="switch">
              <input type='checkbox' checked={currentData.email_notifications} onChange={e => handleChange('email_notifications')({ target: { value: e.target.checked } })} />
              <span className="slider round"></span>
            </label>

          </div>
          <button type='submit' onClick={handleSaveChanges} className={`mid w-full mb-6 btn-loading ${loading ? 'running' : ''}`}>
            <div className="loading"></div>
            {t('generic.save_changes')}
          </button>

        </div>
        <button onClick={handleSignOut} className='mid light w-full'>{t('auth.sign_out')}</button>
      </div>

    </div>
  )
}

export default MyProfile
